import {
  Thead,
  useColorModeValue,
  Tr,
  Th,
  Tbody,
  Td,
  Button,
  HStack,
  IconButton,
  Box,
  Badge,
  Table,
  Tag,
  Image,
  Text,
  Tooltip,
  Icon,
} from '@chakra-ui/react';

import React from 'react';
import { FiUpload, FiEdit2, FiTrash2 } from 'react-icons/fi';
import { useGetImageUrl } from 'src/hooks';
import { GetAllCategoryDishesQuery } from 'src/utils/__generated__/graphql';

interface CategoryListProps {
  categoryDishesData: GetAllCategoryDishesQuery | undefined;
  openEditModal?: (id: React.SetStateAction<null>, name: React.SetStateAction<string>) => void;
  handleDeleteCategory?: (id: any) => void;
  handleFileChange: (event: any, categoryId: string, imageId?: string) => void;
}

export const CategoryList: React.FC<CategoryListProps> = ({
  categoryDishesData,
  openEditModal,
  handleDeleteCategory,
  handleFileChange,
}) => {

  return (
    <Box overflowX="auto">
      <Table variant="simple">
        <Thead bg={useColorModeValue('gray.50', 'gray.800')}>
          <Tr>
            <th>Image</th>
            <Th>Category Name</Th>
            <Th>Foods</Th>
            <Th>Status</Th>
            <Th textAlign="right">Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {categoryDishesData?.category.map((category) => (
            <CategoryRow
              key={category.id}
              category={category}
              openEditModal={openEditModal}
              handleDeleteCategory={handleDeleteCategory}
              handleFileChange={handleFileChange}
            />
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

const CategoryRow = ({ category, openEditModal, handleDeleteCategory, handleFileChange }: any) => {
  const { imageUrl } = useGetImageUrl(category?.image);

  return (
    <Tr key={category.id}>
      <Td>
        {/* ...existing image and upload code... */}
        <Box position="relative" width="140px" height="140px" borderRadius="md" overflow="hidden">
          <Image
            src={imageUrl || '/assets/img/cover-placeholder.jpg'}
            alt="Dish preview"
            objectFit="cover"
            w="100%"
            h="100%"
          />
          <Box position="absolute" bottom={0} left={0} right={0} p={1} bg="blackAlpha.600" backdropFilter="blur(8px)">
            <Button
              as="label"
              width="100%"
              cursor="pointer"
              leftIcon={<Icon as={FiUpload as any} />}
              colorScheme="teal"
              variant="ghost"
              _hover={{ bg: 'blackAlpha.400' }}
            >
              Upload
              <input
                type="file"
                onChange={(e) => handleFileChange(e, category?.id, category?.image)}
                accept="image/*"
                style={{ display: 'none' }}
              />
            </Button>
          </Box>
        </Box>
      </Td>
      <Td>
        <Text fontWeight="medium">{category.name}</Text>
      </Td>
      <Td>
        <Tag
          size="sm"
          colorScheme={(category?.dishes_aggregate?.aggregate?.count ?? 0) > 0 ? 'green' : 'yellow'}
          borderRadius="full"
        >
          {category?.dishes_aggregate?.aggregate?.count ?? 0} items
        </Tag>
      </Td>
      <Td>
        <Badge
          colorScheme={(category?.dishes_aggregate?.aggregate?.count ?? 0) > 0 ? 'green' : 'yellow'}
          borderRadius="full"
        >
          {(category?.dishes_aggregate?.aggregate?.count ?? 0) > 0 ? 'Active' : 'Empty'}
        </Badge>
      </Td>
      <Td textAlign="right">
        <HStack spacing={2} justify="flex-end">
          <Tooltip label="Edit category">
            <IconButton
              size="sm"
              colorScheme="brand"
              variant="ghost"
              icon={<Icon as={FiEdit2 as any} />}
              aria-label="Edit category"
              onClick={() => openEditModal?.(category.id, category.name)}
            />
          </Tooltip>
          <Tooltip label="Delete category">
            <IconButton
              size="sm"
              colorScheme="red"
              variant="ghost"
              icon={<Icon as={FiTrash2 as any} />}
              aria-label="Delete category"
              onClick={() => handleDeleteCategory?.(category.id)}
            />
          </Tooltip>
        </HStack>
      </Td>
    </Tr>
  );
};
